import styled from 'styled-components';
import { useScene } from '../../hooks';
import { useHandle } from '../../hooks/useEditor';
import { HandleData } from '../../types/hooks';

export const ResetViewButton = () => {
  const scene = useScene();
  const [handle, setHandle] = useHandle<HandleData>();

  return (
    <Container
      $hidden={scene.offset.x === 0 && scene.offset.y === 0}
      onClick={() => {
        setHandle({
          x: handle.x - scene.offset.x,
          y: handle.y - scene.offset.y,
        });
        scene.setOffset({ x: 0, y: 0 });
      }}
    >
      Reset view
    </Container>
  );
};

const Container = styled.div<{ $hidden?: boolean }>`
  transform: translateX(calc(-100% - 10px));
  cursor: pointer;
  position: absolute;
  bottom: 0;
  left: 0;
  padding: 10px 15px;

  border-radius: 10px;
  background-color: var(--panel-bg-color);
  font-size: 12px;
  color: var(--text-color-secondary);

  &:hover {
    color: var(--text-color);
    background-color: var(--panel-bg-color-hover);
  }

  ${({ $hidden }) => $hidden && `display: none;`}
`;
